/* eslint-disable react/prefer-stateless-function */
import React, { Component, Fragment } from "react";
import styled from "styled-components";
import EditorLabel from "editor/components/EditorLabel";
import ResetToDefaultProps from "editor/components/ResetToDefaultProps";
import PropsPopover from "editor/components/PropsPopover";
import { PropListItem, PropLabel } from "../styles";
import BorderPopover from "./BorderPopover";

const FlexContainer = styled.div`
  display: flex;
`;

class Border extends Component {
  render() {
    const { label, locale, tooltip, name, defaultValue, updaterFn } =
      this.props;
    const tooltipText = (tooltip && tooltip[locale]) || null;

    return (
      <PropListItem>
        <PropLabel>
          <EditorLabel tooptip={tooltipText}>{label[locale]}</EditorLabel>
        </PropLabel>
        <FlexContainer>
          <ResetToDefaultProps
            name={name}
            defaultProps={defaultValue}
            updaterFn={updaterFn}
          />
          <PropsPopover>
            <Fragment>
              <BorderPopover {...this.props} />
            </Fragment>
          </PropsPopover>
        </FlexContainer>
      </PropListItem>
    );
  }
}

export default Border;
